import { Spinner } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { TanAuthentication } from '@vwfs-its/sf-sac-frontend';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { sendSmsTan, validateSmsTan } from '../../api/save-and-continue';
import { getSession } from '../../redux/slices/appData/app-data.selectors';
import { routes } from '../../routes';
import { setSession } from '../../redux/slices/appData/app-data.slice';
import { trackingService } from '../../tracking/tracking.service';

export const SaveAndContinue = (): JSX.Element => {
  const navigate = useNavigate();

  const [showSpinner, setShowSpinner] = React.useState<boolean>(false);

  const session = useSelector(getSession);
  const brand = process.env.REACT_APP_WEBSITE_BRAND;
  const productName = `${process.env.REACT_APP_BRAND_LABEL} Financial Services`;

  const dispatch = useDispatch();

  React.useEffect(() => {
    trackingService.trackPageView('Continue: Authentication', 'TAN input');
  }, []);

  const sendSMS = () => {
    setShowSpinner(true);
    return sendSmsTan({ transactionId: session?.id as string })
      .then((res: any) => {
        if (res.message !== 'SUCCESS') {
          navigate(routes.error);
        }
      })
      .catch((e: any) => {
        if (e.response?.status === 404 || e.response?.status === 410) {
          navigate(routes.linkExpired);
        } else {
          navigate(routes.error);
        }
      })
      .finally(() => {
        setShowSpinner(false);
      });
  };

  const authorizeTransaction = (transactionId: string, tan: string) => {
    setShowSpinner(true);
    return validateSmsTan({
      transactionId: transactionId,
      tan: tan
    }).then(res => {
      setShowSpinner(false);
      if (res.token) {
        window.sessionStorage.setItem('scDate', (+new Date()).toString());
        dispatch(
          setSession({
            id: transactionId,
            token: res.token
          })
        );
      }
    });
  };

  if (!brand) {
    return <></>;
  }

  return (
    <>
      {showSpinner && <Spinner fullPage />}
      <TanAuthentication
        version={1}
        transactionId={session?.id as string}
        productName={productName}
        externalLinkExpiryMessage={false}
        hideLinkExpiryButton={false}
        visible
        localizationParameters={{
          uk: {
            operationType: 'application'
          }
        }}
        onError={() => {
          navigate(routes.error);
        }}
        customSendRequestTan={sendSMS}
        customSendRequestData={(tan: string, transactionId: string) => {
          return authorizeTransaction(transactionId, tan)
            .catch(() => {
              trackingService.trackPageView('Continue: Authentication', 'Invalid TAN');
              return {
                error: true
              };
            })
            .finally(() => {
              setShowSpinner(false);
            });
        }}
      />
    </>
  );
};
